import { oxfordJoin } from 'common/StringUtils';
import React from 'react';
import { CapacityMessage } from 'src/pages/consumer/order/components/ConsumerOrderCartCapacityWarning';

interface ICartItemSoldOutProps {
  itemDisplayTexts: string[];
}

export const CartItemSoldOutError: React.FC<ICartItemSoldOutProps> = ({ itemDisplayTexts }) => {
  const displayText =
    itemDisplayTexts.length === 1
      ? `${itemDisplayTexts[0]} has sold out for your delivery day and has been removed from your cart.`
      : `${oxfordJoin(itemDisplayTexts)} have sold out for your delivery day and have been removed from your cart.`;
  return (
    <CapacityMessage type='error'>
      <h3>Item Sold Out</h3>
      <span>{displayText}</span>
    </CapacityMessage>
  );
};
